import React from "react";

const Terms = () => {
  return (
    <div className="bg-gray-50 min-h-screen py-16 pt-32 mt-10 px-4 md:px-8">
      <div className="max-w-4xl mx-auto bg-white p-8 md:p-12 rounded-2xl shadow-sm border border-gray-100">
        
        {/* Header Section */}
        <div className="mb-10 pb-6 border-b border-gray-200">
          <h1 className="text-4xl font-extrabold text-gray-900 mb-2">Terms & Conditions</h1>
          <p className="text-gray-500 text-sm">Last Updated: June 13, 2026</p>
        </div>

        {/* Content Section */}
        <div className="space-y-8 text-gray-700 leading-relaxed">
          
          <section>
            <h2 className="text-2xl font-bold text-orange-600 mb-4">1. SMS Terms & Conditions</h2>
            <p>
              By opting into SMS communications from <strong>VitalSource WholeSale LLC DBA </strong>, you agree to receive conversational text messages regarding appointments, service updates, scheduling confirmations, customer support, and other business-related communications.
            </p>
          </section>

          <section className="bg-orange-50 p-6 rounded-xl border border-orange-100">
            <h3 className="font-bold text-orange-800 mb-3">Service Details:</h3>
            <ul className="list-disc pl-5 space-y-2">
              <li><strong>Message Frequency:</strong> Frequency may vary depending on your interaction with our services.</li>
              <li><strong>Carrier Costs:</strong> Message and data rates may apply based on your mobile carrier plan.</li>
              <li><strong>Opt-Out:</strong> You can opt out at any time by replying <strong>STOP</strong> to any message.</li>
              <li><strong>Support:</strong> For assistance, reply <strong>HELP</strong> or contact us via our website at <a href="https://vitalsourcewholesalellc.com/" className="text-orange-600 font-semibold underline">vitalsourcewholesalellc.com</a>.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">2. General Provisions</h2>
            <p>
              Consent to receive SMS messages is not a condition of purchase or service. We value your privacy and ensure that all personal information is handled in accordance with our Privacy Policy.
            </p>
          </section>

        </div>
        
        {/* Footer Info */}
        <div className="mt-12 pt-6 border-t border-gray-100 text-center text-sm text-gray-400">
          &copy; 2026 VitalSource WholeSale LLC DBA . All rights reserved.
        </div>
      </div>
    </div>
  );
};

export default Terms;